import React, { useEffect } from 'react';
import { useLocation, Link, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function Home() {
  const { state } = useLocation();
  const { showToast } = state || {};
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (showToast) {
      toast.success(`Login successful`, {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }
  }, []);

  return (
    <>
      <div className='container-fluid'>
        <div className='shadow m-3 p-2'>
          <div className='row my-2 mx-4'>
            <nav className='col'>
              <div
                className={`${
                  i18n.language === 'en' ? '' : 'd-flex flex-row-reverse'
                } mx-0 nav nav-tabs`}
                id='nav-tab'
                role='tablist'>
                <Link
                  className='nav-item nav-link text-decoration-none'
                  id='nav-welcome-tab'
                  data-toggle='tab'
                  to={'welcome'}
                  role='tab'
                  aria-controls='nav-welcome'
                  aria-selected='true'>
                  {t('homePage.welcome')}
                </Link>
                <Link
                  className='nav-item nav-link text-decoration-none'
                  id='nav-dashboard-tab'
                  data-toggle='tab'
                  to={'dashboard'}
                  role='tab'
                  aria-controls='nav-dashboard'
                  aria-selected='false'>
                  {t('homePage.dashboard')}
                </Link>
              </div>
            </nav>
            <div className='tab-content' id='nav-tabContent'>
              <div
                className='tab-pane fade show active'
                id='nav-welcome'
                role='tabpanel'
                aria-labelledby='nav-welcome-tab'></div>
              <div
                className='tab-pane fade show active'
                id='nav-dashboard'
                role='tabpanel'
                aria-labelledby='nav-dashboard-tab'></div>
            </div>
          </div>

          <Outlet />
        </div>
      </div>
    </>
  );
}

export default Home;
